module.exports = __webpack_public_path__ + "assets/logo-large-alt.211d7c10.svg";